// how it works: https://en.wikipedia.org/wiki/Vehicle_identification_number

import { AbstractControl, ValidatorFn, ValidationErrors } from "@angular/forms";

export class VinValidators {
  static validVinFormat(vin: string): boolean {
    const vinFormatRegex = /^[0-9A-HJ-NPR-Z]{17}$/;
    return vinFormatRegex.test(vin);
  }

  static containsVin(value: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let control_value = control.value;
      return !value.includes(control_value) ? { containsVin: true } : null;
    };
  }

  static validVinCheckDigit(vin: string): boolean {
    const transliterationTable = {
      A: 1,
      B: 2,
      C: 3,
      D: 4,
      E: 5,
      F: 6,
      G: 7,
      H: 8,
      J: 1,
      K: 2,
      L: 3,
      M: 4,
      N: 5,
      P: 7,
      R: 9,
      S: 2,
      T: 3,
      U: 4,
      V: 5,
      W: 6,
      X: 7,
      Y: 8,
      Z: 9,
      "1": 1,
      "2": 2,
      "3": 3,
      "4": 4,
      "5": 5,
      "6": 6,
      "7": 7,
      "8": 8,
      "9": 9,
      "0": 0,
    };
    const weightTable = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

    const products = Array.from(vin).map(
      (char, index) => transliterationTable[char.toUpperCase()] * weightTable[index]
    );

    const checkSum = products.reduce((a, b) => a + b, 0) % 11;
    const checkDigit = checkSum === 10 ? "X" : checkSum.toString();

    return vin[8].toUpperCase() === checkDigit;
  }

  static validVin(vin: string): boolean {
    return VinValidators.validVinFormat(vin) && VinValidators.validVinCheckDigit(vin);
  }

  static checkVinValidity(control: AbstractControl): { [key: string]: any } | null {
    const vin = control.value;
    return vin && !VinValidators.validVin(vin) ? { vinInvalid: true } : null;
  }
}
